import { combineEpics } from "redux-observable";
import { interval } from "rxjs";
import {
    distinctUntilChanged,
    filter,
    first,
    map,
    share,
    switchMap,
    takeUntil,
} from "rxjs/operators";

import { actionCreators } from "../actions";
import { selectIsReconnecting } from "../reducers/errors";
import { Epic } from "../utils/types";

const checkReconnectAttempt: Epic = (action$, state$, { App }) => {
    const hasConnectionLost$ = state$.pipe(
        map(selectIsReconnecting),
        distinctUntilChanged(),
        share() // to re-use same observable for `takeUntil later`
    );
    return hasConnectionLost$.pipe(
        filter(lost => lost),
        switchMap(() =>
            interval(1000).pipe(
                map(() => {
                    const timeMs = App.proto.timeBeforeNextReconnectMs();
                    return actionCreators.updateProtoTimeBeforeReconnect({ timeMs });
                }),
                takeUntil(
                    // connection restored
                    hasConnectionLost$.pipe(
                        filter(lost => !lost),
                        first()
                    )
                )
            )
        )
    );
};

export const errorsEpic = combineEpics(checkReconnectAttempt);
